'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Bowser = require('bowser');
var FingerprintJS = require('@fingerprintjs/fingerprintjs');
var _ = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Bowser__default = /*#__PURE__*/_interopDefaultLegacy(Bowser);
var FingerprintJS__default = /*#__PURE__*/_interopDefaultLegacy(FingerprintJS);
var ___default = /*#__PURE__*/_interopDefaultLegacy(_);

function isOnServer() {
    return typeof window === 'undefined';
}
/**
 * 获取cookie
 * @param {*} cname cookie的名称
 * @param {*} req ctx中的req
 */
function getCookie(cname, req) {
    let name = cname + "=";
    let decodedCookie;
    if (isOnServer()) {
        decodedCookie = decodeURIComponent(req.headers.cookie);
    }
    else {
        decodedCookie = decodeURIComponent(document.cookie);
    }
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return { target: c.substring(name.length, c.length), all: decodedCookie };
        }
    }
    return { target: "", all: "" };
}
function setCookie(name, value, exdays, domain) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${name} = ${value}; ${expires};path=\/; SameSite=Lax; domain=${domain}`;
}
function placeHolder() { }

/** 生成各个指纹 */
function fingerprintEachComponents(components) {
    const _components = JSON.parse(JSON.stringify(components));
    for (let _i = 0, _a = Object.keys(_components).sort(); _i < _a.length; _i++) {
        let componentKey = _a[_i];
        let component = _components[componentKey];
        _components[componentKey].fingerprint = FingerprintJS__default["default"].hashComponents({
            componentKey: component,
        });
    }
    return _components;
}
/** 从百度地图开放平台api获取用户登录地，形如"浙江省杭州市" */
async function getIpLocation() {
    //@ts-ignore
    if (!window.$deviceLocation) {
        const callbackFunctionWrapper = document.createElement("script");
        callbackFunctionWrapper.text =
            "function fingerprintBaiduCallback(data){window.$deviceLocation=(data.content&&data.content.hasOwnProperty('address'))?data.content.address:''}";
        document.head.appendChild(callbackFunctionWrapper);
        const _key = "L6GKmzzwyUUFxMzIT42zk1av58c3ouGj"; //百度地图可以申请到
        let _script = document.createElement("script");
        _script.type = "text/javascript";
        _script.src =
            "https://api.map.baidu.com/location/ip?ak=" +
                _key +
                "&coor=bd09ll&callback=fingerprintBaiduCallback"; //拼接URL
        document.head.appendChild(_script);
    }
}
/** 获取用户的操作系统、浏览器 */
function getDeviceInfo() {
    if (isOnServer()) {
        //只有在客户端才运行本方法
        return { browserName: "", os: "" };
    }
    const ua = window.navigator.userAgent;
    const parser = Bowser__default["default"].getParser(ua);
    //浏览器名字
    const browserName = parser.getBrowserName(true);
    //操作系统
    const os = parser.getOSName(true);
    return { browserName, os };
}
async function collectFingerprints() {
    const fp = await FingerprintJS__default["default"].load();
    const result = await fp.get();
    return {
        integrate: FingerprintJS__default["default"].hashComponents(result.components),
        respective: fingerprintEachComponents(result.components),
    };
}
/** 为当前设备设置一个随机字符串作为唯一标识 */
function createMark() {
    return FingerprintJS.murmurX64Hash128(new Date().toDateString() + Math.random() * 99999);
}
/** 将标识设置到Cookie
 * 返回已有标识或者存入一个新标识并返回
 */
function getMarkFromCookie() {
    let { target: um } = getCookie("um", null);
    if (!um) {
        um = createMark();
        const isBHKK = window.location.hostname.indexOf(".bihukankan.com") >= 0;
        const domain = isBHKK ? ".bihukankan.com" : window.location.hostname;
        setCookie("um", um, 365, domain);
    }
    return um;
}
/** 【指纹监测】将指纹数据处理成后端需要的格式 */
function formatFingerprints2TestInfo(fingerprints) {
    const keys = Object.keys(fingerprints);
    const formated = {
        fingerprint: {},
        duration: {},
    };
    keys.map((fingerprintName) => {
        const ele = fingerprints[fingerprintName];
        formated.fingerprint[fingerprintName] = ele.fingerprint;
        formated.duration[fingerprintName] = ele.duration;
    });
    return formated;
}
/**【指纹监测】收集并发送所需数据 */
async function doPostTestInfo(axios) {
    if (isOnServer()) {
        //只有在客户端才运行本方法
        return;
    }
    //获取浏览器标记
    const browserMark = getMarkFromCookie();
    //获取指纹信息
    const { integrate, respective } = await collectFingerprints();
    //设备信息 包括操作系统、浏览器
    const deviceInfo = getDeviceInfo();
    //userId
    const { target: userId } = getCookie("userId", null);
    axios
        .request({
        method: "post",
        url: "fingerprintApi/data",
        data: {
            ...formatFingerprints2TestInfo(respective),
            browserMark,
            fingerprintValue: integrate,
            appId: process.env["LOGIN_CENTER_APP_ID"],
            deviceInfo,
            //@ts-ignore
            location: window.$deviceLocation,
            userId,
        },
    })
        .catch((error) => { });
}
/**【指纹监测】收集测试指纹的方法
 * 只有收集指纹数据的项目才会用到
 * 一定要确保这些项目都有process.env.NODE_ENV
 * 否则会报错
 */
async function createFingerprintsCollector(axios) {
    const isDev = process.env.NODE_ENV === "development";
    if (isDev || isOnServer())
        return placeHolder;
    else {
        /* 初始化用户定位
        如果在获取location时候用await会阻塞程序初始化进程，造成页面打开缓慢。 */
        getIpLocation();
        return await ___default["default"].throttle(() => doPostTestInfo(axios), 4000);
    }
}
/** 生产环境下获取指纹(通用) */
async function doCollectFingerprintsProduction() {
    const fp = await FingerprintJS__default["default"].load();
    const result = await fp.get();
    //剔除掉部分指纹
    const { deviceMemory, colorDepth, forcedColors, reducedMotion, hdr, screenResolution, contrast, languages, colorGamut, plugins, touchSupport, screenFrame, math, cookiesEnabled, timezone, canvas, audio, domBlockers, fontPreferences, fonts, ...components } = result.components;
    //@ts-ignore
    return FingerprintJS__default["default"].hashComponents(components);
}

exports.createFingerprintsCollector = createFingerprintsCollector;
exports.doCollectFingerprintsProduction = doCollectFingerprintsProduction;
exports.getDeviceInfo = getDeviceInfo;
exports.getIpLocation = getIpLocation;
exports.getMarkFromCookie = getMarkFromCookie;
